import distanceInWordsStrict from 'date-fns/distance_in_words_strict'

/*
 * If we're rendering on the browser yet. Gatsby will server side render before
 * loading the page So window can be undefined.
 */
export const isBrowser = () => typeof window !== `undefined`

/*
 * Compute the number of days/weeks/months years "ago" a particular date is from now
 */
export const relativeDate = dateString => {
  const publishDate = new Date(dateString)
  const now = new Date()
  return distanceInWordsStrict(now, publishDate, {addSuffix: true, partialMethod: 'ceil'})
}
const gcd = (a, b) => (b ? gcd(b, a % b) : a)

export const decimalToFraction = decimal => {
  if (!decimal) return {numerator: 0, denominator: 0}
  const decimalArray = decimal
    .toFixed(5)
    .toString()
    .split('.')
  const leftDecimalPart = decimalArray[0] // 1
  const rightDecimalPart = decimalArray[1] // 75

  let numerator = leftDecimalPart + rightDecimalPart // 175
  let denominator = Math.pow(10, rightDecimalPart.length) // 100
  const factor = gcd(numerator, denominator) // 25
  denominator /= factor
  numerator /= factor

  return {
    numerator,
    denominator,
  }
}
/*
 * isInViewport
 * (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/isInViewport
 *
 * @param  {Node}    elem The element
 * @return {Boolean}      Returns true if element is in the viewport
 */
export const isInViewport = $elem => {
  // Gatsby Server Side Rendering will set window to undefined
  if (typeof window === 'undefined') return false

  const distance = $elem.getBoundingClientRect()
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    // Consider the element in the viewport if the top of the bounding
    // box is inside the window.innerHeight
    distance.bottom - distance.height <=
      (window.innerHeight || window.document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || window.document.documentElement.clientWidth)
  )
}
